module.exports = __webpack_public_path__ + "3a9a6f073e694e33a9cabd5af52b02a7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic_duplicate.png
// module id = 3156
// module chunks = 0